import { render, staticRenderFns } from "./EditQuote.vue?vue&type=template&id=6f5f8ba4&scoped=true"
import script from "./EditQuote.vue?vue&type=script&lang=js"
export * from "./EditQuote.vue?vue&type=script&lang=js"
import style0 from "./EditQuote.vue?vue&type=style&index=0&id=6f5f8ba4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f8ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5f8ba4')) {
      api.createRecord('6f5f8ba4', component.options)
    } else {
      api.reload('6f5f8ba4', component.options)
    }
    module.hot.accept("./EditQuote.vue?vue&type=template&id=6f5f8ba4&scoped=true", function () {
      api.rerender('6f5f8ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditQuote.vue"
export default component.exports